import { openLink } from '@telegram-apps/sdk';
import { createContext } from 'react';

export type InitData = any;

export type InitContextType = {
  closeMiniApp: (returnBack?: boolean) => void;
  error: boolean;
  loading: boolean;
  openLink: typeof openLink;
  token: null | string;
};

export const InitContext = createContext<InitContextType>({
  closeMiniApp: () => {},
  error: false,
  loading: false,
  openLink,
  token: null,
});
